"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuestionBubble = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var QuestionBubble = function QuestionBubble() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6 2H2.4C1.075 2 0 3.094 0 4.444v14.667c0 1.35 1.075 2.445 2.4 2.445h6.108c.315 0 .616.128.84.354l1.788 1.821a.892.892 0 0 0 .636.269h.456a.892.892 0 0 0 .636-.269l1.788-1.821c.224-.226.525-.353.84-.354H21.6c1.325 0 2.4-1.095 2.4-2.445V4.444C24 3.094 22.925 2 21.6 2Zm0 17.111h-6.108c-.954 0-1.87.388-2.544 1.076l-.948.965-.948-.965a3.567 3.567 0 0 0-2.544-1.076H2.4V4.444h19.2v14.667ZM6 11.778c0-3.375 2.686-6.111 6-6.111 1.591 0 3.117.644 4.243 1.79A6.169 6.169 0 0 1 18 11.777c0 3.376-2.686 6.112-6 6.112s-6-2.736-6-6.111Zm6.3 3.666c.166 0 .3-.136.3-.305v-.611a.303.303 0 0 0-.3-.306h-.6c-.166 0-.3.137-.3.306v.61c0 .17.134.306.3.306h.6Zm2.028-5.157a1.763 1.763 0 0 1-1.2 1.668l-.528.19a.08.08 0 0 0-.048.073v.476a.303.303 0 0 1-.3.306h-.456a.303.303 0 0 1-.3-.306v-.476c.001-.495.313-.933.774-1.088l.57-.19a.69.69 0 0 0 .456-.653v-.343a.691.691 0 0 0-.205-.492.665.665 0 0 0-.491-.192h-1.2a.678.678 0 0 0-.672.684v.306a.303.303 0 0 1-.3.306h-.456a.303.303 0 0 1-.3-.306v-.306c0-.972.774-1.76 1.728-1.76h1.2c.458 0 .898.186 1.222.516.324.33.506.778.506 1.244v.343Z",
    fill: "currentColor"
  }));
};

exports.QuestionBubble = QuestionBubble;